import { render } from "./OwnerSet.vue?vue&type=template&id=f422a074&scoped=true&ts=true"
import script from "./OwnerSet.vue?vue&type=script&lang=ts"
export * from "./OwnerSet.vue?vue&type=script&lang=ts"

import "./OwnerSet.vue?vue&type=style&index=0&id=f422a074&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f422a074"]])

export default __exports__